export const mapValueToKey = (array: any, key: string) => {
  let copiedObject: any = {};
  array.forEach((item: any, index: number) => {
    copiedObject[item[key]] = item;
  });
  return copiedObject;
};
